import { Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { toObservable } from '@angular/core/rxjs-interop';
import { combineLatest, Subscription } from 'rxjs';
import { TenantSettingsService } from '@app/core/services/tenant-settings.service';
import { LayoutService } from '@app/core/layout/service/app.layout.service';

@Component({
  selector: 'dynamic-logo',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="layout-topbar-logo-content cursor-pointer" (click)="navigateToHome()">
      <img
        [src]="logoUrl || 'assets/img/logo_color.png'"
        alt="logo"
        [style.height]="size === 'large' ? '130px' : '47px'"
        style="width: auto;"
      />
      <span *ngIf="!logoUrl" style="font-weight: bold;">
        <span>Nest</span><span style="color: #facc15;">Up</span>
      </span>
    </div>
  `,
  styles: [`
    .layout-topbar-logo-content {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      cursor: pointer;
    }
    .layout-topbar-logo-content:hover {
      opacity: 0.8;
      transition: opacity 0.2s ease;
    }
  `],
})
export class DynamicLogoComponent implements OnInit, OnDestroy {
  @Input() size: 'large' | 'medium' = 'medium';

  private tenantSettingsService = inject(TenantSettingsService);
  private layoutService = inject(LayoutService);
  private router = inject(Router);
  private subscription?: Subscription;

  logoUrl: string | null = null;

  // toObservable deve essere chiamato nel contesto di inizializzazione (injection context)
  private config$ = toObservable(this.layoutService.config);

  ngOnInit(): void {
    this.subscription = combineLatest([
      this.tenantSettingsService.getTenantImages(),
      this.config$,
    ]).subscribe(() => {
      const theme = this.layoutService.isDarkTheme() ? 'dark' : 'light';
      this.logoUrl = this.tenantSettingsService.getLogoUrl(theme, this.size);
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  navigateToHome(): void {
    this.router.navigate(['/']);
  }
}
